import { render, staticRenderFns } from "./BarChartist.vue?vue&type=template&id=7f5b8526&"
import script from "./BarChartist.vue?vue&type=script&lang=js&"
export * from "./BarChartist.vue?vue&type=script&lang=js&"
import style0 from "./BarChartist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports